import Nullstack from 'nullstack';
export default function IconDirections({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-directions",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 21v-4"
  }), "   ", Nullstack.element("path", {
    d: "M12 13v-4"
  }), "   ", Nullstack.element("path", {
    d: "M12 5v-2"
  }), "   ", Nullstack.element("path", {
    d: "M10 21h4"
  }), "   ", Nullstack.element("path", {
    d: "M8 5v4h11l2 -2l-2 -2z"
  }), "   ", Nullstack.element("path", {
    d: "M14 13v4h-8l-2 -2l2 -2z"
  }), " ");
}